<style src="./RowDetails.scss" lang="scss"></style>
<template>
  <section class="row-details">
    <section
      v-if="!!info"
      class="description">
      <span class="description">{{ info.itemInfo.description }}</span>

      <div class="iteminfo">
        <span class="number quantity"><small>QT:</small> <strong>{{ info.itemInfo.quantity | DecimalNumber }}</strong></span>
        <span class="number factor"><small>x</small><strong>{{ info.itemInfo.factor | DecimalNumber }}</strong></span>
        <span class="number estimated"><small>ESTIMADO: R$</small> <strong>{{ info.itemInfo.estimatedPrice | CurrencyBR('Não Informado') }}</strong></span>
        <span class="number unity">{{ info.itemInfo.unity }}</span>
      </div>
    </section>

    <section class="quotations">
      <div
        class="loading"
        v-if="waitMode">
        <icon-wait class="wait" />
      </div>
      <div
        v-if="info.associated && info.associated.isAssociated"
        class="item associated">

        <div class="check">
          <icon-check
            class="icon"
            :class="{ 'iconchecked': choosedItemIndex === 'associated' }" />
        </div>

        <div class="type typeassociate">
          <span class="title">
            ASSOCIADO
          </span>
        </div>

        <div class="price command">
          <button
            type="button"
            v-if="editPriceForm.isEditMode"
            @click="saveAssociationPrice"
            class="btn-small-success">
            SALVAR EDIÇÃO
          </button>
          <button
            type="button"
            v-if="editPriceForm.isEditMode"
            @click="cancelPriceEdition"
            class="btn-small-grey">
            CANCELAR EDIÇÃO
          </button>
          <button
            @click="editAssociationItem"
            class="btn-small-default">
            EDITAR ASSOCIAÇÃO
          </button>
          <button
            v-if="!editPriceForm.isEditMode && choosedItemIndex !== 'associated'"
            @click="selectAssociated"
            class="btn-small-default">
            SELECIONAR
          </button>
          <button
            type="button"
            v-if="!editPriceForm.isEditMode"
            @click="openHistoryOfItemPanel"
            class="btn-small-info">
            HISTÓRICO DO ITEM
          </button>
          <button
            v-if="!editPriceForm.isEditMode && choosedItemIndex === 'associated'"
            @click="unselectAssociated"
            class="btn-small-warning">
            DESMARCAR
          </button>
        </div>

        <section class="info">
          <div class="detail">
            <span class="lab">{{ info.associated.lab }}</span>
            <span class="code">{{ info.associated.codProd }}</span>
          </div>
          <span class="pativo">{{ info.associated.pativo }}</span>
          <span class="comercialname">{{ info.associated.comercialName }}</span>

          <div class="aditionalinfo">
            <span class="badge lastbuying">Ult. Compra:&nbsp;<strong>{{ info.associated.lastBuyingDate | DateBR }}</strong></span>
            <span class="badge stock">Qt Estoque:&nbsp;<strong>{{ info.associated.stockQuantity | DecimalNumber }}</strong></span>
          </div>
        </section>

        <div class="price costprice">
          <span class="title">Custo Base</span>
          <form
            v-if="editPriceForm.isEditMode"
            @submit.stop.prevent>
            <input
              class="cp1-small-textbox value textbox"
              v-shortkey="{ escape: ['esc'], saveEdition: ['enter'] }"
              @shortkey="priceTextboxCommand"
              v-model="editPriceForm.price"
              ref="priceTextbox" />
          </form>
          <span
            v-show="!editPriceForm.isEditMode"
            class="price">
            <icon-edit
              @click.native="editAssociatedPrice"
              class="iconedit" />
            <small>R$ </small>
            {{ info.associated.price | CurrencyBR('---,--', 4) }}
          </span>

          <span
            class="title"
            v-if="choosedItemIndex === 'associated'">
            Custo Atual
          </span>
          <div
            class="actualprice"
            :class="{
                'lowerthan': info.associated.stockPrice < info.associated.price,
                'higherthan': info.associated.stockPrice > info.associated.price
              }">
            <span
              v-if="choosedItemIndex === 'associated'"
              class="price">
              <small>R$ </small>
              {{ info.associated.stockPrice | CurrencyBR('---,--', 4) }}
            </span>
          </div>
          
          <span class="title">Total Unitário</span>
          <span class="total"><small>R$ </small>{{ info.associated.priceTotal | CurrencyBR('---,--') }}</span>
        </div>

        <div class="price maxprice">
          <span class="title">Máximo Unitário</span>
          <span class="price"><small>R$ </small>{{ info.associated.cmedPrice | CurrencyBR('---,--', 4) }}</span>

          <span class="title">Máximo Total</span>
          <span class="price"><small>R$ </small>{{ info.associated.cmedPriceTotal | CurrencyBR('---,--') }}</span>
        </div>

        
      </div>
      <div
        v-for="(quote, quotesIdx) in info.quotations"
        :key="quotesIdx"
        class="item quoted"
        :class="{ 'noquoted': quote.notQuote }">

        <div class="check">
          <icon-check
            class="icon"
            :class="{ 'iconchecked': choosedItemIndex === quotesIdx }"/>
        </div>

        <div
          class="type typequote"
          :class="{ 'noquoted': quote.notQuote,
                    'waitingresponse': !quote.receiveDate }">
          <span class="title">
            FORECEDOR
          </span>
        </div>

        <!-- RESPONDED ITEM -->
        <template v-if="!!quote.itemId">
          <div class="price command">
            <button
              v-if="!!quote.itemId && choosedItemIndex !== quotesIdx"
              @click="selectQuoted(quote)"
              class="btn-small-default">
              SELECIONAR
            </button>
            <button
              v-if="choosedItemIndex === quotesIdx"
              @click="unselectAssociated"
              class="btn-small-warning">
              DESMARCAR
            </button>
          </div>

          <section class="info">
            <div class="detail">
              <span class="lab">{{ quote.lab }}</span>
              <span class="code">{{ quote.codProd }}</span>
            </div>
            <span class="pativo">
              <icon-star title="Item com garantia de preço" v-if="quote && quote.isPriceGuaranted" />
              {{ quote.pativo }}
            </span>
            <span class="comercialname">{{ quote.comercialName }}</span>
            <div class="aditionalinfo">
              <span class="badge lastbuying">Ult. Compra:&nbsp;<strong>{{ quote.lastBuyingDate | DateBR }}</strong></span>
              <span class="badge stock">Qt Estoque:&nbsp;<strong>{{ quote.stockQuantity | DecimalNumber(null, null, 0) }}</strong></span>
            </div>
          </section>

          <div class="price costprice">
            <span class="title">Preço Unitário</span>
            <span class="price"><small>R$ </small>{{ quote.price | CurrencyBR('---,--', 4) }}</span>
            
            <span class="title">Total Unitário</span>
            <span class="total"><small>R$ </small>{{ quote.priceTotal | CurrencyBR('---,--') }}</span>
          </div>

          <div class="price maxprice">
            <span class="title">Máximo Unitário</span>
            <span class="price"><small>R$ </small>{{ quote.cmedPrice | CurrencyBR('---,--', 4) }}</span>

            <span class="title">Máximo Total</span>
            <span class="price"><small>R$ </small>{{ quote.cmedTotalPrice | CurrencyBR('---,--') }}</span>
          </div>
        </template>

        <!-- REQUESTED ITEM -->
        <template v-if="!quote.itemId">
          <section class="info">
            <span class="pativo">{{ quote.supplierName }}</span>
            <div class="badges">
              <span class="noquote" v-if="quote.notQuote">NÃO COTADO</span>
              <span class="noreceived" v-if="!quote.receiveDate">AGUARDANDO RETORNO</span>
            </div>
          </section>
          <div class="price costprice">
            <span class="title">Envio</span>
            <span class="price">{{ quote.requestDate | DateBR }}</span>
          </div>

          <div class="price maxprice">
            <span class="title">Recebimento</span>
            <span class="price" v-if="!!quote.receiveDate">{{ quote.receiveDate | DateBR }}</span>
          </div>
        </template>
      </div>
    </section>
  </section>
</template>

<script>
import { CurrencyBR, DecimalNumber, DateBR } from '@/components/primitives/helpers/filters'
import { IconSave, IconStar, IconCheck, IconClose, IconWait, IconEdit } from '@/components/primitives/icons'
import PreparePayloadToSelect from '../../helpers/PreparePayloadToSelect'

export default {
  name: 'RowDetails',
  components: {
    IconStar,
    IconSave,
    IconCheck,
    IconClose,
    IconWait,
    IconEdit
  },
  props: {
    info: {
      default: null
    },
    itemIndex: {
      default: null
    }
  },
  data: () => ({
    editPriceForm: {
      price: 0,
      isEditMode: false
    },
    associatedItem: {},
    finalQuote: {
      supplier: null,
      item: null,
      price: null,
      priceTotal: null,
      isPriceGuaranted: null,
      notQuote: null,
      cmedPrice: null,
      cmedTotalPrice: null,
      cmedLab: null,
      lab: null
    },
    waitMode: false
  }),
  filters: {
    CurrencyBR,
    DecimalNumber,
    DateBR
  },
  computed: {
    choosedItemIndex () {
      const quotedPrice = this.info.quoted.price
      const quotedItemId = this.info.quoted.itemId

      const associatedPrice = this.info.associated.price
      const associatedItemId = this.info.associated.itemId

      const quotationIndex = this.info.quotations.findIndex(i => i.itemId === quotedItemId && i.price === quotedPrice)

      if (quotedPrice === associatedPrice && quotedItemId === associatedItemId) {
        return 'associated'
      }

      return quotationIndex
    }
  },
  watch: {
    'info': {
      handler () {
        this.associatedItem = { ...this.info.associated }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async selectAssociated () {
      try {
        this.waitMode = true
        await this.prepareAssociated({ item: this.info.associated })
      } catch (error) {
        this.$$toasted.error('Não foi possível salvar o associado')
      } finally {
        this.waitMode = false
        this.goToNextRegister()
      }
    },
    async selectQuoted (payload) {
      try {
        this.waitMode = true
        await this.prepareQuoted(payload)
      } catch (error) {
        this.$toasted.error('Não foi possível salvar o associado')
      } finally {
        this.waitMode = false
        this.goToNextRegister()
      }
    },
    goToNextRegister () {
      this.$emit('go-to-next-register')
    },
    async prepareAssociated ({ finalQuotePrice = false, item }) {
      const proposalMargin = this.$store.getters['ItemPricing/PROPOSAL_MARGIN']
      const decimalPrecision = this.$store.getters['ItemPricing/DECIMAL_PRECISION']

      if (finalQuotePrice) {
        item.price = finalQuotePrice
      }

      const quotationPayload = PreparePayloadToSelect({
        item,
        info: this.info,
        proposalMargin,
        decimalPrecision
      })
      await this.saveChoice(quotationPayload)
    },
    async prepareQuoted (item) {
      if (item.notQuote || !item.receiveDate) {
        this.$toasted.error('Não pode escolher esse item')
        return
      }
      const proposalMargin = this.$store.getters['ItemPricing/PROPOSAL_MARGIN']
      const decimalPrecision = this.$store.getters['ItemPricing/DECIMAL_PRECISION']

      const quotationPayload = PreparePayloadToSelect({
        item,
        info: this.info,
        proposalMargin,
        decimalPrecision
      })

      await this.saveChoice(quotationPayload)
    },
    async saveChoice (quotationPayload) {
      try {
        const payload = {
          ...quotationPayload
        }
        const info = await this.$store.dispatch('ItemPricing/SELECT_QUOTE_ITEM', payload)
        this.$store.commit('ItemPricing/SET_ITEM', {
          itemId: this.info.itemId,
          info
        })

        this.$toasted.success('Item salvo')
        return true
      } catch (error) {
        this.$toasted.error('Não foi possível salvar')
        return false
      }
    },
    priceTextboxCommand (command) {
      switch (command.srcKey) {
        case 'escape':
          this.cancelPriceEdition()
          break
        case 'saveEdition':
          this.saveAssociationPrice()
          break
        default:
          break
      }
    },
    cancelPriceEdition () {
      this.editPriceForm.isEditMode = false
    },
    editAssociatedPrice () {
      this.editPriceForm.price = CurrencyBR(this.info.associated.price, null, 4)
      this.editPriceForm.isEditMode = true

      this.$nextTick(() => {
        this.$refs.priceTextbox.focus()
        this.$refs.priceTextbox.selectionStart = 0
        this.$refs.priceTextbox.selectionEnd = this.editPriceForm.price && this.editPriceForm.price.toString().length
      })
    },
    async saveAssociationPrice () {
      this.waitMode = true
      try {
        const price = this.editPriceForm.price.replace('.', '').replace(',', '.')
        const factoredPrice = Number(price) / this.info.itemInfo.factor
        const itemId = this.info.itemId
        const stockId = this.info.associated.itemId
        const isAssociated = this.choosedItemIndex === 'associated'
        await this.saveAssociation({
          itemId,
          stockId,
          price: factoredPrice
        })
        if (isAssociated) {
          await this.prepareAssociated({
            finalQuotePrice: price,
            item: this.info.associated
          })
        }
        await this.refreshList()
        this.cancelPriceEdition()
      } catch (error) {
        this.$tosated.error('Não foi possível salvar esse valor')
      } finally {
        this.waitMode = false
      }
    },
    async saveAssociation ({ itemId, price, stockId }) {
      await this.$store.dispatch('ItemPricing/ASSOCIATE_ITEM', { stockId, itemId, price })
    },
    async refreshList () {
      const eventId = this.$route.params.id
      if (!eventId) return false
      await this.$store.dispatch('ItemPricing/LIST_ALL_ITEMS', { eventId })
    },
    editAssociationItem () {
      this.$emit('edit-association-item', this.info)
    },
    async unselectAssociated () {
      const proposalMargin = this.$store.getters['ItemPricing/PROPOSAL_MARGIN']
      const decimalPrecision = this.$store.getters['ItemPricing/DECIMAL_PRECISION']

      const item = {
        supplier: null,
        item: null,
        price: null,
        priceTotal: null,
        isPriceGuaranted: false,
        notQuote: true,
        lab: false,
        cmedLab: null,
        cmedPrice: null,
        cmedTotalPrice: null,
        proposalTotalPrice: null,
        proposalPerc: null,
        minimumPrice: null,
        minimumTotalPrice: null,
        minimumPerc: null
      }

      const quotationPayload = PreparePayloadToSelect({
        item,
        info: this.info,
        proposalMargin,
        decimalPrecision
      })

      await this.saveChoice(quotationPayload)
    },
    openHistoryOfItemPanel () {
      this.$emit('open-history', this.info)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/row-details/RowDetails.vue